import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';
import { DatenabfrageService } from '../../service/datenabfrage/datenabfrage.service';
import { NotificationService } from '../../service/common/notification/notification.service';
import { DatenabfrageCreateComponent } from '../datenabfrage-create/datenabfrage-create.component';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { AufteilungsschluesselEintragenComponent } from '../netzbetreiber/aufteilungsschluessel-eintragen/aufteilungsschluessel-eintragen.component';
import { Aufteilungsschluessel } from '../../domain/model/datenabfrage/aufteilungsschluessel';
import { DatenabfrageExportService } from '../../service/datenabfrage/datenabfrage-export.service';

@Component({
    selector: 'tnb-aktive-datenabfrage',
    templateUrl: './aktive-datenabfrage.component.html',
    styleUrls: [
        './aktive-datenabfrage.component.scss',
    ],
    standalone: false,
})
export class AktiveDatenabfrageComponent {
    private dialogService = inject(ConfirmDialogService);
    private datenabfrageService = inject(DatenabfrageService);
    private notificationService = inject(NotificationService);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    datenabfrageExportService = inject(DatenabfrageExportService);


    @Input() datenabfrage: Datenabfrage = null;
    @Input() aufteilungsSchluessels: Aufteilungsschluessel[] | [];
    @Input() isWestnetzAdmin: boolean;
    @Input() isWestnetzUser: boolean;
    @Input() isStadtwerk: boolean;

    /* display the submit ATS button */
    @Input() isNvnbAssignedToAktiveDf: boolean;
    @Output() aktiveDfChanged = new EventEmitter<void>();

    public async deleteAktiveDatenabfrage() {
        if (await this.dialogService.confirm(
            'Wenn Sie die Datenabfrage "' + this.datenabfrage.bezeichnung + '" löschen möchten, ' +
            'werden auch alle sämtliche von den Netzbetreibern eingegebenen Aufteilungsschlüssel gelöscht. ' +
            'Diese Aktion ist nicht umkehrbar. ',
            'Datenabfrage löschen',
            'warn',
            'Endgültig löschen',
            'Abbrechen',
            'innogy_picto_bin_c-check',
        )) {
            this.datenabfrageService.deleteAktiveDatenabfrage(this.datenabfrage.id).subscribe(
                () => {
                    this.notificationService.success('Die Datenabfrage wurde gelöscht');
                    this.aktiveDfChanged.emit();
                },
            );
        }
    }

    createAktiveDatenabfrage() {
        this.westnetzSidenavService.openRightnav(DatenabfrageCreateComponent);
        this.westnetzSidenavService.closeRightnav$.subscribe(_ => {
            this.aktiveDfChanged.emit();
        });
    }

    archiviereAktiveDatenabfrage() {
        this.datenabfrageService.archiviereAktiveDatenAbfrage().subscribe(() => {
            this.aktiveDfChanged.emit();
        });
    }

    submitAts() {
        this.westnetzSidenavService.openRightnav(AufteilungsschluesselEintragenComponent);
        this.westnetzSidenavService.closeRightnav$.subscribe(_ => {
            this.aktiveDfChanged.emit();
        });

    }

    csvExportAktiveDatenfrage(datenabfrageId: number) {
        this.datenabfrageExportService.exportAktiveDatenabfrage(datenabfrageId);
    }

    shouldDisplayATSSubmitButton() {
        return !this.isNvnbAssignedToAktiveDf;
    }

    isAktiveDatenabfragePresent() {
        return this.datenabfrage != null && this.datenabfrage.id !== null;
    }
}
